import React, { Component } from "react";
import { withTranslation } from 'react-i18next';

import TilesArea from './TilesArea'
import Tile from '../../Tile'

class DocsArea extends Component {

    onDownloadDocument = (doc) => {
        this.props.onFooterClicked(doc)
    }

    render() {
        const {title, documents, t} = this.props

        const hideLinkLabel = t('StockAwards.DocumentSection.HideDocumentsLink')
        const showLinkLabel = t('StockAwards.DocumentSection.ShowDocumentsLink')
        const hideLinkMobileLabel = t('StockAwards.DocumentSection.HideDocumentsMobileLink')
        const showLinkMobileLabel = t('StockAwards.DocumentSection.ShowDocumentsMobileLink')

        return (
            <TilesArea title={`${title} (${documents.length})`}
                areaId={this.props.areaId}
                collapsed={true}
                className="document-area"
                hideLinkLabel={hideLinkLabel}
                showLinkLabel={showLinkLabel}
                hideLinkMobileLabel={hideLinkMobileLabel}
                showLinkMobileLabel={showLinkMobileLabel}>
                { documents.map((doc, i) =>
                    <li key={`document_${i}`}>
                        <Tile
                            info={doc.title}
                            footerTop={t('StockAwards.DocumentSection.DownloadDocumentLink')}
                            footerMid={this.props.footerMid}
                            footerBottom={this.props.footerBottom}
                            footerMidLabel={t('VestingSummary.TaxBrokerLabel')}
                            footerBottomLabel={t('VestingSummary.NetBrokerLabel')}
                            footer={t('StockAwards.DocumentSection.DownloadDocumentLink')}
                            obj={doc}
                            isClickable
                            onTileClicked={this.onDownloadDocument}
                            theme="default"/>
                    </li>
                )}
            </TilesArea>
        );
    }
}

export default withTranslation("translations")(DocsArea)

